import { Injectable } from '@angular/core';

export type TelemetryTransitionSource = 'next_button' | 'option_auto_advance' | 'conditional_auto_advance' | 'unknown';

export interface TelemetryTransitionContext {
  source: TelemetryTransitionSource;
  triggerFieldKey?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TelemetryTransitionContextService {
  // Telemetry: isolated transition context to avoid changing legacy flow services.
  private pending: TelemetryTransitionContext | null = null;

  setPending(context: TelemetryTransitionContext): void {
    this.pending = context;
  }

  consumePending(): TelemetryTransitionContext | null {
    const current = this.pending;
    this.pending = null;
    return current;
  }
}
